module.exports = __webpack_public_path__ + "ce4767b461ea1386d7be61b9c2e5fe24.svg";